import injectSheet from 'react-jss';
import moment from 'moment';
import {Component} from 'react';
import ReactCountdown from 'react-countdown-now';

const styles = theme => ({
    countdown: {
        backgroundColor: 'white',
        borderRadius: 20,
        border: '1px solid gray',
        color: theme.colors.primary,
        fontFamily: 'monospace',
        fontSize: 42,
        margin: '10px auto',
        padding: 20,
        textAlign: 'center',
        width: '50%',
        '& .timespan': {
            display: 'inline-block',
            '& .increment': {
                color: 'black',
                display: 'block',
                fontSize: 12,
                fontWeight: 'bold',
                textTransform: 'uppercase'
            }
        },
        '& .separator': {
            margin: '0 2px',
            verticalAlign: 'top'
        },
        '@media all and (max-width: 720px)': {
            fontSize: 24,
            width: '95%'
        }
    }
});

const padNumber = num => {
    const s = String(num);
    return s.length < 2 ? `0${s}` : s;
};

const Separator = () => {
    return <span className="separator">:</span>;
};

const Timespan = ({timespan, label}) => {
    return (
        <span className="timespan">
            {timespan}
            <span className="increment">{label}</span>
        </span>
    );
};

class Countdown extends Component {

    countdownRenderer = ({days, hours, minutes, seconds}) => {
        const {classes = {}} = this.props;
        return (
            <div className={classes.countdown}>
                <Timespan timespan={padNumber(days)} label="Days" />
                <Separator />
                <Timespan timespan={padNumber(hours)} label="Hours" />
                <Separator />
                <Timespan timespan={padNumber(minutes)} label="Minutes" />
                <Separator />
                <Timespan timespan={padNumber(seconds)} label="Seconds" />
            </div>
        );
    };

    render() {
        const {date} = this.props;
        return (
            <ReactCountdown
                date={moment(date).format()}
                renderer={this.countdownRenderer} />
        );
    }
}

export default injectSheet(styles)(Countdown);
